import {
  object,
  string,
  ObjectSchema,
  number,
  NumberSchema,
  boolean,
} from 'yup';

const isProfileRequired = (
  profileQuantity: number,
): NumberSchema<number | undefined> =>
  profileQuantity > 1
    ? number()
        .required('Por favor seleccione un perfil')
        .transform((value) => (Number.isNaN(value) ? undefined : value))
    : number()
        .notRequired()
        .transform((value) => (Number.isNaN(value) ? undefined : value));

export default function makeLicenseFormValidation(
  profileQuantity: number,
): ObjectSchema {
  return object().shape({
    license: string().required('Por favor seleccione una licencia'),
    profile: isProfileRequired(profileQuantity),
    // This parameter is used on the custom form
    additionalError: boolean().test(
      'hasErrors',
      'has errors',
      (value) => !value,
    ),
  });
}
